<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" z-index="1000" width="800px" :destroy-on-close="true">
      <el-divider content-position="left">反馈内容</el-divider>
      <div style="width: 100%; border: 1px solid #e5e5e5">
        <p>{{fkParams.fknr}}</p>
      </div>
      <el-divider content-position="left">回复信息</el-divider>
      <div style="width: 100%; border: 1px solid #e5e5e5">
        <p>{{fkParams.hfxx}}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "fkInfo",
    data () {
      return {
        dialogVisible: false,
        fkParams: {
          fknr: '',
          hfxx: ''
        },
      }
    },
    methods: {
      initInfo: function (data) {
        this.fkParams = data
        this.dialogVisible = true
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fkInfo.vue